export default {
    CookiesTitle: {
        en: "We use cookies",
        uk: "Ми використовуємо кукі",
    },
    CookiesMessage1: {
        en: `We and third parties use cookies and similar technologies on this website to improve your online experience, analyse our traffic and provide you with personalized information. By clicking "Accept cookies" below or continuing to browse this website, you consent to the use of `,
        uk: `Ми та треті сторони використовуємо файли cookie та подібні технології на цьому веб-сайті, щоб покращити роботу в Інтернеті, проаналізувати наш трафік і надати вам персоналізовану інформацію. Натиснувши "Прийняти cookie" нижче або продовжуючи перегляд цього веб-сайту, ви погоджуєтеся на використання `,
    },
    CookiesMessageLink: { en: "cookies", uk: "кукі" },
    CookiesMessage2: { en: "and similar technologies.", uk: "і подібні технології." },
    AcceptCookies: { en: "Accept cookies", uk: "Прийняти cookie" },

    CookiesPageTitle: { en: "Cookie Policy", uk: "Політика використання файлів cookie" },
    CookiesPageText: {
        en: `By using the website and other related mobile applications, services and tools, you agree to the
            Privacy Policy and to the use of cookies set by us and third parties, as well as to the use of other
            technologies for tracking actions on the site to ensure its correct operation, in particular , we
            may collect aggregate data about the use of the site in order to improve interaction with you on the
            Internet and manage marketing and service requests to you. You can disable some of the cookies used
            by us, but this may affect the possibility and correctness of using our site (mobile application).

            In compliance with the requirements of the General Data Protection Regulation, adopted by EU
            Regulation 2016/679 (General Data Protection Regulation, GDPR), in the part, related to the
            processing of personal data and the protection of privacy in the electronic communications sector
            e-Privacy Directive, we need your consent to the use of cookies, and their installation on your devices.

            This Cookie Policy sets out the necessary information about the cookies we use, the purposes for
            which these files are used and your rights.`,

        uk: `Використовуючи веб-сайт та інші пов'язані з ним мобільні додатки, сервіси та інструменти, ви погоджуєтеся з
            Політику конфіденційності та на використання встановлених нами і третіми особами файлів cookie, а також на використання інших
            технологій для відстеження дій на сайті з метою забезпечення його коректної роботи, зокрема, ми
            можемо збирати зведені дані про використання сайту з метою поліпшення взаємодії з вами в мережі Інтернет
            Інтернеті та управління маркетинговими і сервісними запитами до вас. Ви можете відключити деякі з використовуваних нами файлів cookie
            нами, але це може вплинути на можливість і коректність використання нашого сайту (мобільного додатку).

            Відповідно до вимог Загального регламенту про захист персональних даних, прийнятого ЄС
            Регламентом ЄС 2016/679 (General Data Protection Regulation, GDPR), в частині, що стосується
            обробки персональних даних та захисту приватності в секторі електронних комунікацій
            Директиви про захист персональних даних, нам потрібна ваша згода на використання файлів cookie та їх встановлення на ваших
            пристрої.

            У цій Політиці використання файлів cookie викладена необхідна інформація про файли cookie, які ми використовуємо, цілі,
            для яких ці файли використовуються, а також ваші права.`,
    },
};
